<template>
  <span>{{ text }}</span>
</template>

<script>
export default {
  name: 'Type',
  props: { type: String },
  computed: {
    text() {
      switch (this.type) {
        case 'new':
          return '新規'
        case 'update':
          return '変更'
        case 'changed':
          return '変更'
        case 'delete':
          return '削除'
        default:
          return ''
      }
    },
  },
}
</script>
